import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Network } from '@capacitor/network';
import { ComponentsModule } from '@components/components.module';
import { GlobalSipCallComponent } from '@components/global-sip-call/global-sip-call.component';
import { environment } from '@environments/environment';
import { User } from '@interfaces/user';
import { IonicModule } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@services/auth.service';
import { JourneyService } from '@services/journey.service';
import { RestService } from '@services/rest.service';
import { SipService } from '@services/sip.service';
import { SocketService } from '@services/socket.service';
import { DpUtilsService } from 'digitup-lib/dist/digitup-lib';
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

initializeApp(environment.firebaseConfig);

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, ComponentsModule, GlobalSipCallComponent],
})
export class AppComponent {
  currentNetworkStatus = true;
  actived?: string;
  simplePage = false;
  // 🔥 Control para mostrar el componente SIP solo para operators
  isOperator = false;

  constructor(
    private translate: TranslateService,
    private utils: DpUtilsService,
    private router: Router,
    private rest: RestService,
    private socketService: SocketService,
    private journeyService: JourneyService,
    private sipService: SipService,
    private authService: AuthService
  ) {
    this.init();
  }

  init() {
    this.translate.use('es');
    this.enableNetwork();
    this.checkCurrentPage();
    this.getCurrentUser();
  }

  async getCurrentUser() {
    const auth = getAuth();
    onAuthStateChanged(auth, async user => {
      console.log('user', user);
      if (user) {
        const currentUser = await this.rest.getCurrentUser(true);
        console.log('currentUser', currentUser);

        // 🔥 Guardar usuario actual y verificar si es operator
        this.isOperator = this.checkIfUserIsOperator(currentUser || undefined);

        // 🔥 Inicializar SIP solo para operators
        if (this.isOperator) {
          console.log('🎯 Usuario es operator, inicializando lógica SIP...');
          // Inicializar auto-conexión para operators
          setTimeout(() => {
            this.sipService.initializeAutoConnect();
            console.log('SIP Service inicializado para operator');
          }, 1000);
        } else {
          console.log('👤 Usuario no es operator, SIP deshabilitado');
        }

        // Проверяем неподписанные контракты для менеджера
        if (currentUser?.role?.includes('manager')) {
          await this.authService.checkProvinceContracts(currentUser);
        }

        if (currentUser?.province?.id) {
          await this.journeyService.getInicialJourneys(currentUser.province.id);
        }
        this.socketService.initSocket(user);

        setTimeout(() => {
          console.log('Listner main inited', this.socketService.listnerMainInited);
          console.log('Listner calculator inited', this.socketService.listnerCalculatorInited);
        }, 3000);
      }
    });
  }

  // 🔥 Método para verificar si el usuario tiene rol operator
  private checkIfUserIsOperator(user: User | undefined): boolean {
    if (!user?.role) return false;
    return user.role.includes('operator');
  }

  async enableNetwork() {
    setTimeout(async () => {
      console.log('enable network');
      // const statusStart = await Network.getStatus();
      // console.log('statusStart', statusStart);
      // if (statusStart && !statusStart.connected) {
      //   await this.utils.showToast({ message: 'Problemas con conexión a Internet', cssClass: 'warning' });
      // }
      Network.addListener('networkStatusChange', async (status) => {
        console.log('Network status changed', status);
        if (status && !status.connected && this.currentNetworkStatus) {
          this.currentNetworkStatus = false;
          await this.utils.showToast({ message: 'Problemas con conexión a Internet', cssClass: 'warning' });
        } else if (status && status.connected && !this.currentNetworkStatus) {
          this.currentNetworkStatus = true;
        }
      });
    }, 3000);
  }

  checkCurrentPage() {
    this.router.events.subscribe(async (event) => {
      if (event instanceof NavigationEnd) {
        this.actived = event.url.split('/')[1].split('#')[0];
        if (['login'].includes(this.actived) ||
          ['reset-password'].includes(this.actived) ||
          ['create-driver'].includes(this.actived) ||
          ['create-manager'].includes(this.actived) ||
          ['stripe-setup-success', 'stripe-setup-cancel'].includes(this.actived) ||
          this.actived.includes('action')
        ) {
          this.simplePage = true;
        } else {
          this.simplePage = false;
        }
      }
    });
  }

}
